import { useEffect, useState } from "react";

// STYLES
import * as Style from "./AuditStyle";

// LIBRARIES

// MISC
import { Tabs } from "models/GeneralTypes/generalTypes";
import {
  IAuditApiParams,
  IFilters,
  IRentalsLogsTableData,
  ISmsLogsTableData,
} from "models/interfaces";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { getRentalLogs, getSMSLogs } from "api/auditApi";
import {
  language,
  selectedTab,
  toggleActiveTab,
  toggleAuditTabs,
} from "slices/uiSlice";
import {
  rentalsLogsData,
  rentalLogsTotalPages,
  rentalLogsFilters,
  toggleClearRentalsLogsTableData,
} from "slices/auditSlice";
import {
  smsLogsData,
  smsLogsFilters,
  smsLogsTotalPages,
  toggleClearSmsLogsTableData,
} from "slices/auditSlice";

// COMPONENTS
import TabsComponent from "components/Tabs/Tabs";
import FiltersComponent from "components/FiltersComponent/FiltersComponent";
import DynamicTable from "components/Table/Table";
import { filters, handleResetFiltersState } from "slices/filtersSlice";
import moment from "moment";

const Audit = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector<string>(selectedTab);
  const rentalsLogsTableDatas =
    useAppSelector<IRentalsLogsTableData>(rentalsLogsData);
  const rentalLogsTotalPage = useAppSelector<number>(rentalLogsTotalPages);
  const smsTableDatas = useAppSelector<ISmsLogsTableData[]>(smsLogsData);
  const smsTotalPage = useAppSelector<number>(smsLogsTotalPages);
  const smsLogFiltersValue = useAppSelector<IAuditApiParams>(smsLogsFilters);
  const rentalLogsFiltersValue =
    useAppSelector<IAuditApiParams>(rentalLogsFilters);
  const selectedLanguage = useAppSelector<string>(language);
  const filtersData = useAppSelector<IFilters>(filters);

  // CONSTANTS USING HOOKS
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    dispatch(toggleAuditTabs());
    dispatch(toggleActiveTab(Tabs.RENTALS_LOGS));
    // dispatch(handleResetFiltersState());
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIsLoading(true);
    let payload: IAuditApiParams = {
      fullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      lockerId: filtersData.lockerSelectValue,
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    if (activeTab === Tabs.RENTALS_LOGS) {
      dispatch(getRentalLogs(payload))
        .unwrap()
        .then(() => {
          dispatch(toggleClearSmsLogsTableData());
          setIsLoading(false);
        });
    } else if (activeTab === Tabs.SMS_LOGS) {
      dispatch(getSMSLogs(payload))
        .unwrap()
        .then(() => {
          dispatch(toggleClearRentalsLogsTableData());
          setIsLoading(false);
        });
    }
    //eslint-disable-next-line
  }, [activeTab, smsLogFiltersValue, rentalLogsFiltersValue, selectedLanguage]);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  return (
    <Style.AuditContainer>
      <FiltersComponent />
      {!isLoading ?
        <>
          {rentalsLogsTableDatas &&
            <DynamicTable
              totalPages={rentalLogsTotalPage}
              tableData={rentalsLogsTableDatas}
            />
          }
          {smsTableDatas &&
            <DynamicTable
              totalPages={smsTotalPage}
              tableData={smsTableDatas}
            />
          }
        </> : <Style.LodingSign />
      }
    </Style.AuditContainer>
  );
};

export default Audit;
